import {
  Component,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CountrydetailpageService } from '../countrydetailpage.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { FormsModule } from '@angular/forms';
import { CountryListDropdown } from 'src/app/shared/components/country-dropdown/country-dropdown.component';

@Component({
  selector: 'app-country-detail-hero',
  templateUrl: './country-detail-hero.component.html',
  styleUrls: ['./country-detail-hero.component.scss'],
  imports: [CommonModule, FormsModule, CountryListDropdown],
})
export class CountryDetailHeroComponent implements OnInit, OnDestroy, OnChanges {
  @Input() pageData: any;
  constructor(
    private countryDetailPageService: CountrydetailpageService,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  heroData: any;
  reqBody: any;
  gbpBody: any;
  gbpChange: any;
  today = new Date();
  outAmount = 0;
  convertRate = 0;
  @ViewChild('inAmount', { static: true }) inAmount: any;
  @ViewChild('inRate', { static: true }) inRate: any;
  @ViewChild('outRate', { static: true }) outRate: any;
  currencies: any;
  currencyFrom: string = 'USD';
  currencyTo: string = '';
  isButtonEnabled: boolean = false;
  noData: boolean = false;
  selectedCountryCode1 = 'usd';
  selectedCountryCode2: string = '';
  countryCodes: any = [];
  customLabels: any = {};
  noValueErrMsg: string = '';
  unsupportedCurrencyMsg: string = '';
  isUnsupportedCurrency: boolean = true;

  previousFromCurrency = 'USD';
  previousToCurrency = '';
  isWeakToCurrency = false;
  oldGbpData: any = null;

  ngOnInit(): void {
    
  }
  ngOnChanges(): void {
    const data = this.pageData;
    
    // Initialize heroData even on server to prevent template errors
    if (data != null && data?.heroContentPanel?.fields) {
      this.heroData = {
        image: {
          url: data?.heroContentPanel?.fields?.image?.[0]?.fields?.file?.url,
          alt: data?.heroContentPanel?.fields?.image?.[0]?.fields?.title,
        },
        currency: data?.currency,
        country: data?.id?.toString()?.split('/')?.[1],
      };
      this.currencyTo = data?.currency;
      let string = data?.currency;
      string = string?.toLowerCase();
      this.selectedCountryCode2 = string;

      this.previousFromCurrency = this.currencyFrom;
      this.previousToCurrency = this.currencyTo;
    }

    // Only run browser-specific code on the client
    const isServer = !isPlatformBrowser(this.platformId);
    if (isServer) return;

    this.http.get(environment.currencyAPIlist).subscribe((data: any) => {
      this.currencies = data.items;
      for (let i = 0; i < this.currencies.length; i++) {
        let string = this.currencies[i]?.label || '';
        let string2 = this.currencies[i]?.label || '';
        string = string.toLowerCase();
        this.countryCodes.push(string);
        this.customLabels[string] = string2;
      }
      this.countryCodes = this.countryCodes.sort();
    }, (err: any) => {
      console.error('Error fetching currency list:', err);
    });

    if (this.currencyTo) {
      this.gbpBody = {
        currencyFrom: {
          label: this.currencyFrom,
        },
        currencyTo: {
          label: this.currencyTo,
        },
      };

      if (
        this.currencyFrom == this.currencyTo &&
        this.currencyFrom.toLowerCase() == 'usd'
      ) {
        this.currencyTo = 'GBP';
        this.selectedCountryCode2 = 'gbp';
      }
      if (this.currencyFrom != this.currencyTo) {
        this.http.post(environment.currencyAPI, this.gbpBody).subscribe(
          data => {
            if (data != null) {
              this.gbpChange = data;
              this.isUnsupportedCurrency = false;
              if (this.gbpChange.rateAfterSpread > 100) {
                this.isWeakToCurrency = true;
              } else {
                this.isWeakToCurrency = false;
              }
            }
          },
          (err: any) => {
            if (err.error?.code == 400) {
              this.isUnsupportedCurrency = true;
              this.currencyTo = 'GBP';
              this.selectedCountryCode1 = 'usd';
              this.selectedCountryCode2 = 'gbp';
              this.getGBPToUSDCurrencyData();
            }
          }
        );
      }
    }
  }
  collectValue(e: any) {
    if (this.gbpChange == null || this.gbpChange == undefined) {
      this.inAmount.nativeElement.value = 0;
      this.outAmount = 0;
      return;
    }
    this.inAmount.nativeElement.value =
      !!e.target.value && Math.abs(e.target.value) >= 0
        ? Math.abs(e.target.value)
        : 0;

    let num =
      this.inAmount.nativeElement.value * this.gbpChange.rateAfterSpread;
    this.outAmount = Math.round(num * 100) / 100;
    if (this.inAmount.nativeElement.value > 0) {
      //this.isButtonEnabled = true;
      this.noValueErrMsg = '';
    } else {
      //this.isButtonEnabled = false;
      this.noValueErrMsg = 'Please enter a valid amount';
    }
  }

  getInRate() {
    this.calculateAmount(
      this.inAmount.nativeElement.value,
      this.selectedCountryCode1,
      this.selectedCountryCode2
    );
  }

  calculateAmount(enterAmount: any, incurrency: any, outcurrency: any) {
    const isServer = !isPlatformBrowser(this.platformId);
    if (isServer) return;
    let inRate = this.customLabels[incurrency];
    let outRate = this.customLabels[outcurrency];
    this.currencyFrom = inRate;
    this.currencyTo = outRate;
    let body = {
      currencyFrom: {
        label: inRate,
      },
      currencyTo: {
        label: outRate,
      },
    };

    if (inRate != outRate) {
      this.http.post(environment.currencyAPI, body).subscribe(
        (data: any) => {
          if (data != null) {
            this.gbpChange = data;
            if (this.gbpChange.rateAfterSpread > 100) {
              this.isWeakToCurrency = true;
            } else {
              this.isWeakToCurrency = false;
            }

            let num = enterAmount * this.gbpChange.rateAfterSpread;
            this.outAmount = Math.round(num * 100) / 100;
            this.isUnsupportedCurrency = false;
          }
        },
        (err: any) => {
          if (err.error.code == 400) {
            this.isUnsupportedCurrency = true;
            this.currencyTo = 'USD';
            this.selectedCountryCode1 = 'gbp';
            this.selectedCountryCode2 = 'usd';
            this.getGBPToUSDCurrencyData();
            //At this moment we support the currency - {{currency}} in a limited manner. We do support G10 currency payments to and from {{country}}.
          }
        }
      );
    }
  }

  getGBPToUSDCurrencyData() {
    const isServer = !isPlatformBrowser(this.platformId);
    if (isServer) return;
    let body = {
      currencyFrom: {
        label: 'GBP',
      },
      currencyTo: {
        label: 'USD',
      },
    };
    this.http.post(environment.currencyAPI, body).subscribe(
      data => {
        if (data != null) {
          this.gbpChange = data;
          let num = 1 * this.gbpChange.rateAfterSpread;
        }
      },
      (err: any) => {}
    );
  }

  invertCurrency() {
    //Save previous pair
    this.previousFromCurrency = this.currencyFrom;
    this.previousToCurrency = this.currencyTo;
    this.oldGbpData = Object.assign({}, this.gbpChange);

    let inRate = this.customLabels[this.selectedCountryCode1];
    let outRate = this.customLabels[this.selectedCountryCode2];
    let x = this.selectedCountryCode1;
    let y = this.selectedCountryCode2;

    let curFrom = inRate;
    let curTo = outRate;
    this.selectedCountryCode1 = y;
    this.selectedCountryCode2 = x;
    this.currencyFrom = curTo;
    this.currencyTo = curFrom;
    this.calculateAmount(
      this.inAmount.nativeElement.value,
      this.selectedCountryCode1,
      this.selectedCountryCode2
    );
  }

  changeSelectedCountryCode1(value: string): void {
    this.selectedCountryCode1 = value;
    this.getInRate();
  }
  changeSelectedCountryCode2(value: string): void {
    this.selectedCountryCode2 = value;
    this.getInRate();
  }

  sendNow() {
    if (
      !this.inAmount.nativeElement.value ||
      (this.inAmount.nativeElement.value &&
        this.inAmount.nativeElement.value <= 0)
    ) {
      this.noValueErrMsg = 'Please enter amount';
      return;
    } else {
      this.noValueErrMsg = '';
    }
    let url = `https://exchange.verto.co/auth/login?c1=${this.currencyFrom}&v1=1&c2=${this.currencyTo}`;
    window.open(url, '_blank');
  }
}
